module.exports = __webpack_public_path__ + "static/media/aramex.1ca98693.png";